import { Box, CircularProgress } from '@mui/material';
import { FC, lazy, Suspense, useEffect, useState } from 'react';
import type { CKEditorProps } from './ckeditor';

const CKEditorInner = lazy(() => import('./ckeditor-inner'));

const CKEditorFallback: FC = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight={120}
    p={2}>
    <CircularProgress size={24} />
  </Box>
);

/** Loads CKEditor in a separate chunk after first paint. */
export const CKEditorLazy: FC<CKEditorProps> = (props) => {
  const [canMount, setCanMount] = useState(false);

  useEffect(() => {
    setCanMount(true);
  }, []);

  if (!canMount) {
    return <CKEditorFallback />;
  }

  return (
    <Suspense fallback={<CKEditorFallback />}>
      <CKEditorInner {...props} />
    </Suspense>
  );
};

export default CKEditorLazy;
